/* tslint:disable */
/* eslint-disable */
/**
 * Mr.Bilit Authentication api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, RequiredError } from '../base';
// @ts-ignore
import { MagicLinkResponse } from '../model';
// @ts-ignore
import { RegisterRequest } from '../model';
// @ts-ignore
import { RegisterResponse } from '../model';
/**
 * RegisterApiApiRegisterGetSignUpMagicLinkGet - axios parameter creator
 * 
 * @summary  (Auth policies: auth:CanGetMagicLink)
 * @param {string} [mobile] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function RegisterApiApiRegisterGetSignUpMagicLinkGetAxiosParamCreator (mobile?: string, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/register/getSignUpMagicLink`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (mobile !== undefined) {
        localVarQueryParameter['mobile'] = mobile;
    }



    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}
/**
 * RegisterApiApiRegisterPost - axios parameter creator
 * 
 * @param {string} [xPlayerid] 
 * @param {RegisterRequest} [registerRequest] 
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
async function RegisterApiApiRegisterPostAxiosParamCreator (xPlayerid?: string, registerRequest?: RegisterRequest, options: AxiosRequestConfig = {}, configuration?: Configuration): Promise<RequestArgs> {
    const localVarPath = `/api/register`;
    // use dummy base URL string because the URL constructor only accepts absolute URLs.
    const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
    let baseOptions;
    if (configuration) {
        baseOptions = configuration.baseOptions;
    }

    const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
    const localVarHeaderParameter = {} as any;
    const localVarQueryParameter = {} as any;

    // authentication bearer required
    // http bearer authentication required
    await setBearerAuthToObject(localVarHeaderParameter, configuration)

    if (xPlayerid != null) {
        localVarHeaderParameter['x-playerid'] = String(xPlayerid);
    }



    localVarHeaderParameter['Content-Type'] = 'application/json';

    setSearchParams(localVarUrlObj, localVarQueryParameter);
    let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
    localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
    localVarRequestOptions.data = serializeDataIfNeeded(registerRequest, localVarRequestOptions, configuration)

    return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
    };
}

/**
 * Request parameters for apiRegisterGetSignUpMagicLinkGet operation in RegisterApi.
 * @export
 * @interface RegisterApiApiRegisterGetSignUpMagicLinkGetRequest
 */
export interface RegisterApiApiRegisterGetSignUpMagicLinkGetRequest {
    /**
     * 
     * @type {string}
     * @memberof RegisterApiApiRegisterGetSignUpMagicLinkGet
     */
    readonly mobile?: string
}

/**
 * Request parameters for apiRegisterPost operation in RegisterApi.
 * @export
 * @interface RegisterApiApiRegisterPostRequest
 */
export interface RegisterApiApiRegisterPostRequest {
    /**
     * 
     * @type {string}
     * @memberof RegisterApiApiRegisterPost
     */
    readonly xPlayerid?: string

    /**
     * 
     * @type {RegisterRequest}
     * @memberof RegisterApiApiRegisterPost
     */
    readonly registerRequest?: RegisterRequest
}

/**
* 
* @summary  (Auth policies: auth:CanGetMagicLink)
* @param {RegisterApiApiRegisterGetSignUpMagicLinkGetRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function RegisterApiApiRegisterGetSignUpMagicLinkGet(requestParameters: RegisterApiApiRegisterGetSignUpMagicLinkGetRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await RegisterApiApiRegisterGetSignUpMagicLinkGetAxiosParamCreator(requestParameters.mobile, options, configuration);
    const request: () => AxiosPromise<MagicLinkResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
/**
* 
* @param {RegisterApiApiRegisterPostRequest} requestParameters Request parameters.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export async function RegisterApiApiRegisterPost(requestParameters: RegisterApiApiRegisterPostRequest = {}, options?: AxiosRequestConfig, configuration?: Configuration) {
    const localVarAxiosArgs = await RegisterApiApiRegisterPostAxiosParamCreator(requestParameters.xPlayerid, requestParameters.registerRequest, options, configuration);
    const request: () => AxiosPromise<RegisterResponse> = createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
    return request();
}
